export function normalizeFastenResult(r) {
    var _a, _b;
    return {
        id: r.id,
        name: r.name,
        score: (_a = r.score) !== null && _a !== void 0 ? _a : null,
        source: "fasten",
        sortName: r.sortName,
        brandIds: r.brandIds,
        portals: r.portals,
        logoUrl: (_b = r.logoUrl) !== null && _b !== void 0 ? _b : null,
        locations: r.locations,
    };
}
export function normalizeEpicResult(r) {
    var _a, _b;
    return {
        id: r.id,
        name: r.name,
        score: (_a = r.score) !== null && _a !== void 0 ? _a : null,
        source: "epic",
        url: r.url,
        careFacilityName: (_b = r.careFacilityName) !== null && _b !== void 0 ? _b : null,
    };
}
const DEFAULT_FASTEN_SCORE_THRESHOLD = 10;
const DEFAULT_EPIC_SCORE_THRESHOLD = 1;
const SCORE_TIE_TOLERANCE = 0.01;
function normalizeToUnitScale(score, min, max) {
    if (score === null || score === undefined)
        return 0;
    if (max <= min)
        return 1;
    return (score - min) / (max - min);
}
function confidenceFactor(maxRawScore, threshold) {
    if (threshold <= 0)
        return 1;
    return Math.min(1, maxRawScore / threshold);
}
export function mergeAndSortLocationsByScore(fasten, epic, options) {
    var _a, _b;
    const fastenThreshold = (_a = options === null || options === void 0 ? void 0 : options.fastenScoreThreshold) !== null && _a !== void 0 ? _a : DEFAULT_FASTEN_SCORE_THRESHOLD;
    const epicThreshold = (_b = options === null || options === void 0 ? void 0 : options.epicScoreThreshold) !== null && _b !== void 0 ? _b : DEFAULT_EPIC_SCORE_THRESHOLD;
    const fastenScores = fasten.map((r) => r.score).filter((s) => s !== null && s !== undefined);
    const epicScores = epic.map((r) => r.score).filter((s) => s !== null && s !== undefined);
    const fastenMin = fastenScores.length ? Math.min(...fastenScores) : 0;
    const fastenMax = fastenScores.length ? Math.max(...fastenScores) : 0;
    const epicMin = epicScores.length ? Math.min(...epicScores) : 0;
    const epicMax = epicScores.length ? Math.max(...epicScores) : 0;
    const fastenConfidence = confidenceFactor(fastenMax, fastenThreshold);
    const epicConfidence = confidenceFactor(epicMax, epicThreshold);
    const normalizedFasten = fasten.map((r) => ({
        ...normalizeFastenResult(r),
        score: normalizeToUnitScale(r.score, fastenMin, fastenMax) * fastenConfidence,
    }));
    const normalizedEpic = epic.map((r) => ({
        ...normalizeEpicResult(r),
        score: normalizeToUnitScale(r.score, epicMin, epicMax) * epicConfidence,
    }));
    const merged = [...normalizedEpic, ...normalizedFasten];
    merged.sort((a, b) => {
        var _a, _b, _c, _d;
        const scoreA = (_a = a.score) !== null && _a !== void 0 ? _a : 0;
        const scoreB = (_b = b.score) !== null && _b !== void 0 ? _b : 0;
        if (Math.abs(scoreA - scoreB) <= SCORE_TIE_TOLERANCE) {
            return ((_c = a.name) !== null && _c !== void 0 ? _c : "").localeCompare((_d = b.name) !== null && _d !== void 0 ? _d : "", undefined, { sensitivity: "base" });
        }
        return scoreB - scoreA;
    });
    return merged;
}
export function toFastenSearchResult(p) {
    var _a, _b;
    if (p.source !== "fasten")
        return null;
    return {
        id: p.id,
        name: p.name,
        score: (_a = p.score) !== null && _a !== void 0 ? _a : undefined,
        sortName: p.sortName,
        brandIds: p.brandIds,
        portals: p.portals,
        logoUrl: (_b = p.logoUrl) !== null && _b !== void 0 ? _b : undefined,
        locations: p.locations,
    };
}
